const NEGATIVE_SYMBOL = '-';

export const negativeValue = (value?: string): string => {
  if (!value) return '';

  return value[0] === NEGATIVE_SYMBOL ? value : `${NEGATIVE_SYMBOL}${value}`;
};
